export default defineNuxtPlugin(() => {
  if (import.meta.client) {
    // Override console.warn to filter out Pinia readonly warnings
    const originalWarn = console.warn;
    console.warn = (...args) => {
      const message = args[0]?.toString() || "";

      // Filter out Pinia readonly warnings during development
      if (message.includes('Set operation on key "value" failed: target is readonly')) {
        // Only log in development and not too frequently
        if (process.env.NODE_ENV === "development" && Math.random() < 0.1) {
          console.debug("Pinia readonly warning (filtered):", ...args);
        }
        return;
      }

      // Filter out hydration warnings that are expected
      if (message.includes("Hydration completed but contains mismatches")) {
        console.debug("Hydration mismatch (expected):", ...args);
        return;
      }

      // Pass through other warnings
      originalWarn.apply(console, args);
    };

    // Handle unhandled promise rejections
    window.addEventListener("unhandledrejection", (event) => {
      const reason = event.reason?.message || event.reason?.toString() || "";

      if (
        reason.includes("parentNode") ||
        reason.includes("Hydration") ||
        reason.includes("readonly")
      ) {
        console.debug("Filtered unhandled rejection:", event.reason);
        event.preventDefault(); // Prevent the error from being logged
      }
    });

    // Handle regular errors
    window.addEventListener("error", (event) => {
      const message = event.error?.message || event.message || "";

      if (
        message.includes("parentNode") ||
        message.includes("Hydration") ||
        message.includes("readonly")
      ) {
        console.debug("Filtered error:", event.error);
        event.preventDefault(); // Prevent the error from being logged
      }
    });
  }
});
